module.exports = __webpack_public_path__ + "img/icon4.40519948.png";